import * as React from "react";
import RenderAnswerSelect from "./RenderAnswerSelect";
import RenderAnswerBox from "./RenderAnswerBox";
import RenderMultiSelect from "./RenderMultiSelect";

const RenderWizardUI = (props: any) => {
    const AnswerList: any = props.question.AnswerSchema.EnumValues == null ? props.question.AnswerSchema.Items.EnumValues : props.question.AnswerSchema.EnumValues;
    const showMultiSelect: boolean = props.question.AnswerSchema.Type === "array";
    const showSelect: boolean = props.question.AnswerSchema.Type === "string";
    const showAnswerBox: boolean = props.question.AnswerSchema.Type === "integer";
    let answer = {} as any;

    const onChange = (value: string) => {
        if (value != null) {
            answer[props.question.Id] = value;
            props.setAnswer(answer);
        }
    };

    return (
        <React.Fragment>
            <div key={props.question.Id}>
                {showSelect && (
                    <RenderAnswerSelect
                        answerList={AnswerList}
                        answer={props.answer}
                        onChange={onChange}
                        Title={props.question.AnswerSchema.Title}
                        id={props.question.Id}
                    />
                )}
                {showAnswerBox && (
                    <RenderAnswerBox
                        answerType={props.question.AnswerSchema.Type}
                        answer={props.answer}
                        onChange={onChange}
                        Title={props.question.AnswerSchema.Title}
                        id={props.question.Id}
                    />
                )}
                {showMultiSelect && (
                    <RenderMultiSelect
                        answerList={AnswerList}
                        answer={props.answer}
                        onChange={onChange}
                        Title={props.question.AnswerSchema.Title}
                        id={props.question.Id}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default RenderWizardUI;
